<template>
  <div class="detail-item">
    <div class="row">
      <div class="col-12 col-md">
        <trs-form-sent-alert v-if="trsMode && trsFormSentMode && !orderPage"></trs-form-sent-alert>
        <referral v-if="iquote.referralCode"></referral>

        <div class="row">
          <div class="col-12 col-md">
            <card-intro v-if="!isGeneric || isBattery" :quote="quote"></card-intro>
            <detail-list-options :quote="quote"></detail-list-options>
          </div>
          <div v-if="!isGeneric" class="col-12 col-md">
            <detail-image :quote="quote"></detail-image>
          </div>
          <div v-else class="col-12 col-md order-md-1 mt-5 mt-md-0">
            <card-additional-information :quote="quote"></card-additional-information>
          </div>
        </div>

        <!-- Temporarily disabled because the savings calculations are not ready yet. -->
        <!-- <div v-if="!isGeneric" class="row">
          <div class="col-12 col-md-6 order-md-1 mb-5">
            <detail-list-options :quote="quote"></detail-list-options>
          </div>
          <div class="col-12 col-md order-md-2 mb-5">
            <card-savings :quote="quote" :desktop="desktop"></card-savings>
          </div>
        </div> -->

        <trs-form v-if="trsMode" :id="quote.id"></trs-form>
      </div>
    </div>
  </div>
</template>

<script>
import CardIntro from '@/components/parts/CardIntro'
// import CardSavings from '@/components/parts/CardSavings'
import DetailImage from '@/components/quotes/DetailImage'
import DetailListOptions from '@/components/quotes/DetailListOptions'
import Referral from '@/components/quotes/Referral'
import TrsForm from '@/components/quotes/trsForm/TrsForm'
import TrsFormSentAlert from '@/components/quotes/trsForm/TrsFormSentAlert'
import { mapGetters } from 'vuex'
import CardAdditionalInformation from '../parts/CardAdditionalInformation.vue'

export default {
  props: {
    quote: {
      type: Object,
      required: true,
    },
    desktop: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  name: 'DetailQuote',
  computed: {
    orderPage() {
      return this.$route.name === 'OrderDetail'
    },
    ...mapGetters(['trsFormSentMode', 'isGeneric', 'isBattery']),
  },
  components: {
    CardIntro,
    // CardSavings,
    DetailImage,
    DetailListOptions,
    Referral,
    TrsForm,
    TrsFormSentAlert,
    CardAdditionalInformation,
  },
  methods: {
    selectOrder() {
      this.$router.push({
        name: 'OrderSummary',
        params: { id: this.quote.id },
      })
    },
  },
}
</script>
